export const logictics_heading = [
    {
        title: "Solution For"      
    },
    {
        title: "Transportation & Logistics"
    },
  ];  